import { render, staticRenderFns } from "./LeaderBoardComponent.vue?vue&type=template&id=ddfcc344"
import script from "./LeaderBoardComponent.vue?vue&type=script&lang=js"
export * from "./LeaderBoardComponent.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoardComponent.vue?vue&type=style&index=0&id=ddfcc344&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports